module.exports = __webpack_public_path__ + "static/img/kjdy_raw.bedbb04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/kjdy_raw.png
// module id = 1231
// module chunks = 0